import {
    CLEAR_RFID_DATA,
    GET_RFID_COUNT,
    GET_RFID_FOR_MAP,
    GET_RFID_STATUS_LIST,
    GET_RFID_TAG_HISTORY,
    GET_RFID_TAGS,
    GET_SUB_ASSET_RFID_TAGS,
    GET_SUB_ASSETS_FOR_MAP,
    RFID_ERROR,
    RFID_LOADING,
    RFID_LOADING_FALSE,
    RFID_TAG_ACTIVATED,
    RFID_TAG_DEACTIVATED,
    RFID_TAG_DELETED,
    RFID_TAG_UPDATED
} from '../actions/rfidAction';
import Skeleton from "@mui/material/Skeleton";
import {getUnique} from "./subCustomerReducer";

export const RFID_SUMMARY_ITEMS = [
    {
        value: 'total',
        imgpath: '/static/images/summary/rfid.svg',
        alt: 'Total RFID Tags',
        title: 'Total RFID Tags',
        display: '40',
        statusDot: null,
        onClick: (history) => {
            history.push('/rfid?id=history');
        }
    },
    {
        key: 1,
        value: 'active',
        imgpath: '/static/images/summary/active.svg',
        alt: 'Active RFID Tags',
        title: 'Active RFID Tags',
        display: '32',
        statusDot: '#4CAF50', // Green for active
        onClick: (history) => {
            history.push('/rfid?id=history&key=1');
        }
    },
    {
        key: 2,
        value: 'inactive',
        imgpath: '/static/images/summary/deactive.svg',
        alt: 'Inactive RFID Tags',
        title: 'Inactive RFID Tags',
        display: '06',
        statusDot: '#F44336', // Red for inactive
        onClick: (history) => {
            history.push('/rfid?id=history&key=2');
        }
    },
    {
        key: 4,
        value: 'unused',
        imgpath: '/static/images/summary/rfid_not_used.svg',
        alt: 'Unused RFID Tags',
        title: 'Unused RFID Tags',
        display: '02',
        statusDot: null,
        onClick: (history) => {
            history.push('/rfid?id=history&key=4');
        }
    }
];

const initialState = {
    loading: false,
    error: null,
    rfidTags: [],
    rfidTagHistory: [],
    rfidHistory: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    subAssetsForMap: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    rfidForMap: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    subAssetRfidTags: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    rfidSummary: {
        total: 0,
        active: 0,
        inactive: 0,
        unused: 0
    },
    hasNextPage: false,
    rfidList: []
};

const AssetTypeBlue = {
    1: {
        imgpath: "/static/images/icons/Asset_svgs_blue/trucks.svg",
        Title: "Trucks",
        assetType: "1",
    },
    2: {
        imgpath: "/static/images/icons/Asset_svgs_blue/car.svg",
        Title: "Cars",
        Title1: "",
        assetType: "2",
    },
    3: {
        imgpath: "/static/images/icons/Asset_svgs_blue/dg_set.svg",
        Title: "DG_SET",
        Title1: "",
        assetType: "3",
    },
    4: {
        imgpath: "/static/images/icons/Asset_svgs_blue/infra.svg",
        Title: "Infrastructure",
        assetType: "4",
    },
    5: {
        imgpath: "/static/images/icons/Asset_svgs_blue/machinery.svg",
        Title: "Machinery",
        assetType: "5",
    },
    6: {
        imgpath: "/static/images/icons/Asset_svgs_blue/others_blue.svg",
        Title: "Others",
        Title1: "",
        assetType: "6",
    },
    7: {
        imgpath: "/static/images/icons/Asset_svgs_blue/bus.svg",
        Title: "Buses",
        Title1: "",
        assetType: "7",
    },
};

const mapSubAssetRfidTagsToRfidTags = (subAssetRfidTags) => {
    if (!subAssetRfidTags) {
        return [];
    }

    return subAssetRfidTags.map((tag, index) => {
        // Map status codes to text and labels
        // ACTIVE = 1, IN_ACTIVE = 2, USED = 3, UN_USED = 4, P_REMOVED = 5
        let statusText, statusLabel, statusColor;

        switch (tag.status) {
            case 1:
                statusText = 'active';
                statusLabel = 'ACTIVE';
                statusColor = '#4CAF50'; // Green
                break;
            case 2:
                statusText = 'inactive';
                statusLabel = 'INACTIVE';
                statusColor = '#F44336'; // Red
                break;
            case 3:
                statusText = 'used';
                statusLabel = 'USED';
                statusColor = '#2196F3'; // Blue
                break;
            case 4:
                statusText = 'unused';
                statusLabel = 'UNUSED';
                statusColor = '#FF9800'; // Orange
                break;
            case 5:
                statusText = 'removed';
                statusLabel = 'Permanently Removed';
                statusColor = '#42526E'; // Gray
                break;
            default:
                statusText = 'unknown';
                statusLabel = 'UNKNOWN';
                statusColor = '#757575'; // Default gray
        }

        return {
            id: tag.id || index.toString(), // Use index as id if no unique id is available
            icon: '/static/images/summary/rfid.svg', // Default icon
            title: tag.subcustomer || tag?.sub_customer || tag.name || `RFID Tag ${tag.rfid}`, // Use subcustomer as title or fallback to RFID
            rfidTag: tag.rfid,
            status: statusText,
            statusLabel: statusLabel,
            statusColor: statusColor,
            detailPath: `/rfid/details/${tag.rfid}`,
            updatedAt: tag.updated_at,
            subasset_type: AssetTypeBlue[tag.subasset_type]?.imgpath || tag.subasset_type,
            subAssetName: tag.sub_customer,
            incharge: tag.asset_incha || 'Not Available',
            rcNumber: tag.rc_number || 'Not Available',
            date: tag.date || tag?.updated_at || 'Not Available',
        };
    });
};

const rfidReducer = (state = initialState, action) => {
    switch (action.type) {
        case RFID_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case RFID_LOADING_FALSE:
            return {
                ...state,
                loading: false
            };

        case RFID_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_RFID_TAGS:
            return {
                ...state,
                rfidTags: action.payload,
                error: null
            };

        case GET_RFID_TAG_HISTORY:
            return {
                ...state,
                rfidTagHistory: action.payload,
                error: null
            };

        case GET_RFID_STATUS_LIST: {
            const isFirstPage = !action.payload.offset || action.payload.offset === 0;
            const mappedResults = mapSubAssetRfidTagsToRfidTags(action.payload?.results);
            const updatedResults = isFirstPage 
                ? mappedResults 
                : [...state.rfidHistory.results, ...mappedResults];
            
            return {
                ...state,
                rfidHistory: {
                    ...action.payload,
                    results: getUnique(state?.rfidHistory?.results?.concat(updatedResults), "id")
                },
                rfidList: updatedResults,
                hasNextPage: Boolean(action.payload.next),
                error: null
            };
        }

        case GET_SUB_ASSETS_FOR_MAP: {
            const isFirstPage = !action.payload.offset || action.payload.offset === 0;
            const mappedResults = mapSubAssetRfidTagsToRfidTags(action.payload?.results);
            const updatedResults = isFirstPage 
                ? mappedResults 
                : [...state.subAssetsForMap.results, ...mappedResults];
            
            return {
                ...state,
                subAssetsForMap: {
                    ...action.payload,
                    results: getUnique(state?.subAssetsForMap?.results?.concat(updatedResults), "id")
                },
                rfidList: updatedResults,
                hasNextPage: Boolean(action.payload.next),
                error: null
            };
        }

        case GET_RFID_FOR_MAP:
            return {
                ...state,
                rfidForMap: {
                    count: action.payload.count,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    results: getUnique(state?.rfidForMap?.results?.concat(action?.payload?.results), "id") || [],
                },
                error: null
            };

        case GET_SUB_ASSET_RFID_TAGS: {
            const isFirstPage = !action.payload.offset || action.payload.offset === 0;
            const mappedResults = mapSubAssetRfidTagsToRfidTags(action.payload?.results);
            const updatedResults = isFirstPage 
                ? mappedResults 
                : [...state.subAssetRfidTags.results, ...mappedResults];
            
            return {
                ...state,
                subAssetRfidTags: {
                    ...action.payload,
                    results: getUnique(state?.subAssetRfidTags?.results?.concat(updatedResults), "id")
                },
                rfidList: updatedResults,
                hasNextPage: Boolean(action.payload.next),
                error: null
            };
        }

        case RFID_TAG_ACTIVATED: {
            // Update activated tag in status list
            return {
                ...state,
                rfidStatusList: action.payload,
                error: null
            };
        }

        case RFID_TAG_DEACTIVATED: {
            // Update deactivated tag in status list
            return {
                ...state,
                rfidStatusList: action.payload,
                error: null
            };
        }

        case RFID_TAG_UPDATED: {
            // Replace RFID value in status list
            return {
                ...state,
                rfidStatusList:action.payload,
            };
        }

        case RFID_TAG_DELETED: {
            // Remove deleted tag from status list
            return {
                ...state,
                rfidStatusList: action.payload,
                error: null
            };
        }

        case GET_RFID_COUNT: {
            return {
                ...state,
                rfidCount: RFID_SUMMARY_ITEMS
                    .filter(item => !(item.value === 'unused' && action.payload?.data?.[item.value] === 0))
                    .map(item => ({
                        imgpath: item.imgpath,
                        alt: item.alt,
                        Title: item.title,
                        borderClass: true,
                        ...(item.statusDot && {statusDot: item.statusDot}),
                        Values: {
                            display: item.display,
                            display2: action.payload?.data?.[item.value] === undefined
                                ? <Skeleton variant="text"/>
                                : action.payload?.data?.[item.value]
                        },
                        onClick: item.onClick
                    })),
                error: null
            }
        }

        case CLEAR_RFID_DATA:
            return  {
                ...state,
                loading: false,
                error: null,
                rfidTags: [],
                rfidTagHistory: [],
                rfidHistory: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                },
                subAssetsForMap: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                },
                rfidForMap: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                },
                subAssetRfidTags: {
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                },
                rfidSummary: {
                    total: 0,
                    active: 0,
                    inactive: 0,
                    unused: 0
                },
                hasNextPage: false,
                rfidList: []
            };

        default:
            return state;
    }
};

export default rfidReducer;